import React from "react"

import { Select, Spin, Divider, Input, Button, Space } from "antd"
import { PlusOutlined, RightOutlined } from "@ant-design/icons"

import debounce from "lodash/debounce"

const { Option, OptGroup } = Select
import t from "../i18n"
import { nanoid } from "nanoid"
export default class AutocompleteSearch extends React.Component {
  constructor(props) {
    super(props)
    this.lastFetchId = 0
    this.fetchData = debounce(this.fetchData, 800)
    this.state = {
      data: [],
      fetching: false,
      value: this.props.value,
      name: "",
      name_ar: "",
      componentId: nanoid(),
    }
  }

  fetchData = (value) => {
    if (value == "") return
    this.lastFetchId += 1
    const fetchId = this.lastFetchId
    this.setState({ data: [], fetching: true })

    const url =
      Biscraft.routes.api.autocomplete_search_path +
      `/${this.props.searchFor}` +
      "?q=" +
      value +
      "&extra_params=" +
      (this.props.extraParams ? this.props.extraParams : "") +
      "&token=" +
      Spree.api_key

    fetch(url)
      .then((response) => response.json())
      .then((results) => {
        if (fetchId !== this.lastFetchId) {
          // for fetch callback order
          return
        }
        const data = results
        const found = data?.length > 0
        console.log("data::", data)
        this.setState({ data, found, fetching: false })
      })
  }

  translate = () => {
    console.log(`ill translate soon!`)
    const { name } = this.state
    const toField = this.toTarget
    const $this = this
    var url =
      "https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=ar&dt=t&q=" +
      encodeURI(name)
    fetch(url)
      .then(function (response) {
        return response.json()
      })
      .then(function (myJson) {
        $this.setState({ name_ar: myJson[0][0][0] })
      })
  }
  handleChange = (value, isAddNew = false) => {
    const {
      selectionHandler,
      copyValueToElementSelector,
      containerElementSelector,
    } = this.props
    const { componentId } = this.state
    this.setState(
      {
        value,
        data: [],
        fetching: false,
      },
      () => {
        debugger
        if (containerElementSelector) {
          const selector = containerElementSelector
          let containerElm
          if (isAddNew) {
            const reactElement = document.getElementById(componentId)
            // Query the relative parent element using jQuery
            containerElm = $(reactElement).closest(selector)
          } else {
            containerElm = $(`${selector}:contains('${value.value}')`)
          }
          containerElm.find(copyValueToElementSelector).val(value.value)
        } else if (copyValueToElementSelector) {
          $(copyValueToElementSelector).val(value.value)
        }

        if (selectionHandler) {
          if (typeof selectionHandler === "string") {
            window[selectionHandler](value)
          } else {
            selectionHandler(value)
          }
        }
      }
    )
  }
  onNameChange = (event) => {
    this.setState({ name: event.target.value })
  }
  onNameArChange = (event) => {
    this.setState({ name_ar: event.target.value })
  }
  addItem = (e) => {
    e.preventDefault()

    const url =
      Biscraft.routes.api.autocomplete_search_path +
      "/create_by_name" +
      "?token=" +
      Spree.api_key
    console.log("url", url)
    const postData = { name: this.state.name, name_ar: this.state.name_ar }
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(postData),
    })
      .then((response) => response.json())
      .then((product) => {
        // const data = product
        // const found = data?.length > 0
        console.log("product::", product)
        this.setState({ name: "", name_ar: "" })
        const newValue = {
          label: `${product.name} ${product.name_ar ?? ""}`,
          value: product.id,
        }
        this.handleChange(newValue, true)
      })
      .catch((error) => {
        // Handle any errors
        console.error("Error adding new product:", error)
      })
    // this.setState({ data: [...this.state.data, this.state.name], name: "" })
  }
  render() {
    const { fetching, data, value } = this.state
    const { name, name_ar, componentId } = this.state

    var options = []
    if (this.props.searchFor == "products") {
      data.forEach((p) => {
        if (p.variants && p.variants.length > 1) {
          options.push(
            <OptGroup label={p.product_name}>
              {p.variants.map((d) => (
                <Option key={d.variant_id}>
                  {d.variant_name} {d.variant_name_ar}{" "}
                </Option>
              ))}
            </OptGroup>
          )
        } else {
          options.push(
            <Option key={p.variant_id}>
              {p.product_name} {p.product_name_ar}
            </Option>
          )
        }
      })
    } else {
      options = data.map((d) => <Option key={d.value}>{d.text}</Option>)
    }

    return (
      <div style={{ backgroundColor: "blue" }} id={componentId}>
        <input
          type="hidden"
          value={value?.value}
          className="selected-id-store"
        />
        <Select
          labelInValue
          showSearch
          value={value}
          defaultValue={this.props.defaultValue}
          mode={this.props.mode}
          placeholder={this.props.placeholder}
          style={this.props.style || { width: "100%" }}
          defaultActiveFirstOption={false}
          showArrow={true}
          filterOption={false}
          onSearch={this.fetchData}
          onSelect={this.handleChange}
          onChange={this.handleChange}
          notFoundContent={
            fetching ? (
              <Spin size="small" />
            ) : (
              <div>{t("enter_name_above")}</div>
            )
          }
          disabled={this.props.disabled}
          dropdownRender={(menu) => (
            <div>
              {menu}
              {/*
              <div>
                <Divider style={{ margin: "4px 0" }} />
                <div
                  style={{ display: "flex", flexWrap: "nowrap", padding: 8 }}
                >
                  <Input
                    style={{ flex: "auto" }}
                    value={name}
                    onChange={this.onNameChange}
                    placeholder="Enter new item"
                  />
                  <Button type="dashed" block onClick={this.addItem}>
                    <PlusOutlined /> Add item
                  </Button>
                </div>
              </div> */}
              <>
                <Divider
                  style={{
                    margin: "8px 0",
                  }}
                />
                <div
                  style={{ display: "flex", flexWrap: "nowrap", padding: 8 }}
                >
                  <Space
                    style={{
                      padding: "0 8px 4px",
                    }}
                  >
                    <Input
                      placeholder="Name in English"
                      value={name}
                      onChange={this.onNameChange}
                    />
                    <Button
                      type="text"
                      icon={<RightOutlined />}
                      onClick={this.translate}
                    ></Button>
                    <Input
                      placeholder="Name in Arabic"
                      value={name_ar}
                      onChange={this.onNameArChange}
                      direction="rtl"
                    />
                  </Space>

                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={this.addItem}
                  >
                    Add item
                  </Button>
                </div>
              </>
            </div>
          )}
        >
          {options}
        </Select>
      </div>
    )
  }
}

// ReactDOM.render(<UserRemoteSelect />, mountNode);
{
  /* {data.map(d => (
          <Option key={d.value}>{d.text}</Option>
        ))} */
}
